export const permission = {
    SETUP_UPDATE: "setup.update",
    SETUP_OP_MANAGE: "setup.manage",

    CREATE_ADOBE_IO: "adobe_io_integration.create",
    EDIT_ADOBE_IO: "adobe_io_integration.update",
    DELETE_ADOBE_IO: "adobe_io_integration.delete",
    EDIT_ADOBE_IO_OP_EDIT_DEFAULT: "adobe_io_integration.edit.default",

    CREATE_TEALIUM: "tealium_integration.create",
    EDIT_TEALIUM: "tealium_integration.update",
    DELETE_TEALIUM: "tealium_integration.delete",
    EDIT_TEALIUM_OP_EDIT_DEFAULT: "tealium_integration.edit.default",

    EDIT_WORKSPACE_OP_EDIT_DEFAULT: "workspace.edit.default",

    CREATE_AEM_ADOBE_IO: "aem_adobe_io_integration.create",
    EDIT_AEM_ADOBE_IO: "aem_adobe_io_integration.update",
    DELETE_AEM_ADOBE_IO: "aem_adobe_io_integration.delete",
    EDIT_AEM_ADOBE_IO_OP_EDIT_DEFAULT: "aem_adobe_io_integration.edit.default",

    MANAGE_EXP_OP_BULK_ACTION_PREVIEW: "experience.bulk_action.preview",
    MANAGE_EXP_OP_BULK_ACTION_ACTIVATE: "experience.bulk_action.activate",
    MANAGE_EXP_OP_BULK_ACTION_UPLOAD: "experience.bulk_action.upload",

    CREATE_EXP_OP_EDIT_EXP_CODE: "experience.create.experience_code.update",
    CREATE_EXP_OP_CREATE_OFFER: "experience.create.offer.create",
    CREATE_EXP_OP_EDIT_OFFER: "experience.create.offer.update",
    CREATE_EXP_OP_UPDATE_AEM: "experience.create.update_aem",
    CREATE_EXP_OP_CREATE_CONTENTFUL: "experience.create.contentful.create",
    CREATE_EXP_OP_CHOOSE_TEMPLATE: "experience.create.steps.choose_template",
    CREATE_EXP_OP_CHOOSE_TEMPLATE_VIEW_GALLERY: "experience.create.choose_template_view.gallery",
    CREATE_EXP_OP_CHOOSE_TEMPLATE_VIEW_LIST: "experience.create.choose_template_view.list",
    CREATE_EXP_OP_CHOOSE_TEMPLATE_VIEW_PREVIEW: "experience.create.choose_template_view.preview",
    CREATE_EXP_OP_CONFIGURE_EXPERIENCE: "experience.create.steps.configure_experience",
    CREATE_EXP_OP_CREATE_EXPERIENCE: "experience.create.steps.create_experience",
    CREATE_EXP_OP_ACTIVATE: "experience.create.steps.activate_experience",

    EDIT_EXP_OP_EDIT_EXP_CODE: "experience.edit.experience_code.update",
    EDIT_EXP_OP_CREATE_OFFER: "experience.edit.offer.create",
    EDIT_EXP_OP_EDIT_OFFER: "experience.edit.offer.update",
    EDIT_EXP_OP_UPDATE_AEM: "experience.update.update_aem",
    EDIT_EXP_OP_CREATE_CONTENTFUL: "experience.edit.contentful.create",
    EDIT_EXP_OP_UPDATE_CONTENTFUL: "experience.edit.contentful.update",
    CREATE_EXP_OP_CREATE_TEALIUM: "experience.create.tealium.create",
    CREATE_EXP_OP_UPDATE_TEALIUM: "experience.edit.tealium.update",
    EDIT_EXP_OP_CONFIGURE_EXPERIENCE: "experience.edit.steps.configure_experience",
    EDIT_EXP_OP_EDIT_EXPERIENCE: "experience.edit.steps.edit_experience",
    EDIT_EXP_OP_ACTIVATE: "experience.edit.steps.activate_experience",
    SHOW_AI_GENERATE_VARIANTS: "experience.create.ai.generate_variants",
    SHOW_AI_GENERATE_FIELDS: "experience.create.ai.generate_fields",


    EDIT_OFFER: "offer.update",
    EDIT_OFFER_OP_EDIT_OFFER_CODE: "offer.edit.offer_code.update",

    CREATE_TEALIUM_AUDIENCE_STREAM: "tealium_audience_stream.create",
    EDIT_TEALIUM_AUDIENCE_STREAM: "tealium_audience_stream.update",
    DELETE_TEALIUM_AUDIENCE_STREAM: "tealium_audience_stream.delete",

    CREATE_ADOBE_TARGET_AUDIENCES: "adobe_target_audiences.create",
    EDIT_ADOBE_TARGET_AUDIENCES: "adobe_target_audiences.update",
    DELETE_ADOBE_TARGET_AUDIENCES: "adobe_target_audiences.delete",

    CREATE_ADOBE_TARGET_AUDIENCES_CONFIG_RULE: "adobe_target_audience_config_rule.create",
    EDIT_ADOBE_TARGET_AUDIENCES_CONFIG_RULE: "adobe_target_audience_config_rule.update",

    TEMPLATE_CREATE: "template.create.create_template_cta",
    TEMPLATE_OP_CREATE_SOURCE_API: "template.create.source.api",
    TEMPLATE_UPDATE: "template.update",
    TEMPLATE_DELETE: "template.delete",
    TEMPLATE_OP_EDIT_PREVIEW: "template.edit.preview",
    TEMPLATE_OP_BULK_PREVIEW: "template.bulk_preview",

    AEM_CONTENT_FRAGMENT_OP_CREATE_PREVIEW: "aem_content_fragment.create.preview",
    AEM_CONTENT_FRAGMENT_OP_OFFER: "aem_content_fragment.offer",

    CONTENTFUL_ENTRY_OP_OFFER: "contentful_eateries.offer",

    GITHUB_ENTRY_OP_OFFER: "github_entries.offer",

    MANAGE_PROFILE_OP_DEACTIVATE_ACCOUNT: "manage_profile.deactivate_account",

    MANAGE_ORGANIZATION_OP_RENAME: "manage_organization.rename",
    MANAGE_ORGANIZATION_OP_DEACTIVATE: "manage_organization.deactivate",

    MANAGE_USERS_OP_INVITE_USER: "manage_users.invite_user",
    MANAGE_USERS_OP_DEACTIVATE_ACCOUNT: "manage_users.deactivate_account",
    MANAGE_USERS_OP_EDIT_NAME: "manage_users.edit.name",
    MANAGE_USERS_OP_EDIT_ROLE: "manage_users.edit.role",
    MANAGE_USERS_OP_PASSWORD: "manage_users.edit.password",

    FUNCTIONS_ONE_OFF_TASK_CREATE :"functions.one_off_task.create",
    FUNCTIONS_ONE_OFF_TASK_DOWNLOAD :"functions.one_off_task.download",
    FUNCTIONS_RECURRING_TASK_CREATE :"functions.recurring_task.create",
    FUNCTIONS_SAVED_TASK_EDIT :"functions.saved_task.edit",
    FUNCTIONS_SAVED_TASK_DELETE :"functions.saved_task.delete",
    FUNCTIONS_SAVED_TASK_DUPLICATE :"functions.saved_task.duplicate",

    AUDIENCE_TEALIUM_AUDIENCE_STREAM_OP_ADD_TO_ADOBE_TARGET: "adobe_target_audiences.tealium_audience_stream.add_to_adobe_target",

    // --- XCM Tests ---
    XCM_TESTS_VIEW: "xcm.tests.view",
    XCM_TESTS_CREATE: "xcm.tests.create",
    XCM_TESTS_UPDATE: "xcm.tests.update",
    XCM_TESTS_DELETE: "xcm.tests.delete",

    // --- XCM Schedule ---
    XCM_SCHEDULE_VIEW: "xcm.schedule.view",
    XCM_SCHEDULE_MANAGE: "xcm.schedule.manage",

    // --- XCM Programme Health ---
    XCM_PROGRAMME_HEALTH_VIEW: "xcm.programme_health.view",

    // --- XCM Learnings ---
    XCM_LEARNINGS_VIEW: "xcm.learnings.view",
    XCM_LEARNINGS_CREATE: "xcm.learnings.create",
    XCM_LEARNINGS_UPDATE: "xcm.learnings.update",
    XCM_LEARNINGS_DELETE: "xcm.learnings.delete",

    // --- XCM Settings ---
    XCM_SETTINGS_VIEW: "xcm.settings.view",
    XCM_SETTINGS_LOCATIONS_CREATE: "xcm.settings.locations.create",
    XCM_SETTINGS_LOCATIONS_UPDATE: "xcm.settings.locations.update",
    XCM_SETTINGS_LOCATIONS_DELETE: "xcm.settings.locations.delete",

    XCM_SETTINGS_CHECKLISTS_CREATE: "xcm.settings.checklists.create",
    XCM_SETTINGS_CHECKLISTS_UPDATE: "xcm.settings.checklists.update",
    XCM_SETTINGS_CHECKLISTS_DELETE: "xcm.settings.checklists.delete",

    XCM_SETTINGS_TAGS_CREATE: "xcm.settings.tags.create",
    XCM_SETTINGS_TAGS_UPDATE: "xcm.settings.tags.update",
    XCM_SETTINGS_TAGS_DELETE: "xcm.settings.tags.delete",
}
